module.exports = __webpack_public_path__ + "pc/img/screencapture-vinylc-ko-about-2022-11-03-10_11_05.5c636739.png";